import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { STORAGE_KEY } from "app/app-constant";
import { AuthService } from "app/core/auth/auth.service";
import { of, switchMap, tap } from "rxjs";

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  // Check the authentication status
  return authService.check().pipe(
    switchMap((authenticated) => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Redirect to the sign-in page with a redirectUrl param
        const redirectURL =
          state.url === "/sign-out" ? "" : `redirectURL=${state.url}`;
        const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

        return of(urlTree);
      }

      // If authenticated, check userConfig
      // const storedConfig = localStorage.getItem(STORAGE_KEY.USER_CONFIG);
      // if (!storedConfig) {
        return authService.userConfig().pipe(
          tap((config) => {
            localStorage.setItem(
              STORAGE_KEY.USER_CONFIG,
              JSON.stringify(config.data)
            ); // Store directly in localStorage
          }),
          switchMap(() => of(true)) // Allow access after setting config
        );
      // }

      // Allow the access
      return of(true);
    })
  );
};
